<template>
    <div class="pl-1">
        <slot v-if="ssr" name="body" />
        <template v-else>
            <template v-if="quarters != null">
                <span 
                    v-for="quarter in quarters" 
                    :key="quarter.title" 
                    :class="'badge badge-' + $root.network" 
                    >{{ quarter['title'] }}</span>
            </template>
        </template>
    </div>
</template>
<script>
export default {
    data() {
        return {
            ssr: true,
            quarters: null
        }
    },

    mounted() {
        window.events.$on('list.quarters', event => {
            this.quarters = event;
            this.ssr = false;
        })
    }
}
</script>